export function registerSW(config = {}) {
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`; // Path to your Service Worker file

      navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
          console.log("Service Worker registered:", registration);

          // Check for updates
          registration.addEventListener("updatefound", () => {
            const newWorker = registration.installing;
            newWorker.addEventListener("statechange", () => {
              if (newWorker.state === "installed") {
                if (navigator.serviceWorker.controller) {
                  // New update available
                  console.log("New update available!");
                  if (config.onUpdate) {
                    config.onUpdate(registration); // Trigger the update notification
                  }
                } else {
                  // First installation
                  console.log("App is ready for offline use.");
                }
              }
            });
          });

          // Listen for controllerchange event
          navigator.serviceWorker.addEventListener("controllerchange", () => {
            console.log("Controller changed. Reloading the page...");
            window.location.reload(); // Reload the page to load the new version
          });
        })
        .catch((error) => {
          console.error("Service Worker registration failed:", error);
        });
    });
  }
}